<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content" >
      <myHeader ref="myHeader"></myHeader>
      <!-- 学生选择列表 -->
      <div class="organiza-txt studentList" v-if="listType">
        <div class="organiza-list">
          <div class="list-title">选择练习题</div>
          <div class="searchBox clear">
            <div class="search-item">
              <p>文章/题干：</p>
              <input type="text" placeholder="请输入要搜索的文章/题干" v-model="listObj.title">
            </div>
            <div style="display: block;margin: 20px 0;">
              <div class="search-item">
                <p>文章一级标签：</p>
                <el-select placeholder="请选择" v-model="listObj.material_label_one" @change="articleLabel('1',$event)">
                  <el-option
                    v-for="item in articleOneList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.title">
                  </el-option>
                </el-select>
              </div>
              <div class="search-item">
                <p>文章二级标签：</p>
                <el-select placeholder="请选择" v-model="listObj.material_label_two" @change="articleLabel('2',$event)">
                  <el-option
                    v-for="item in articleTwoList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.title">
                  </el-option>
                </el-select>
              </div>
              <div class="search-item">
                <p>文章三级标签：</p>
                <el-select placeholder="请选择" v-model="listObj.material_label_three" @change="articleLabel('3',$event)">
                  <el-option
                    v-for="item in articleThreeList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.title">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div style="display: block;">
              <div class="search-item">
                <p>题干一级标签：</p>
                <el-select  placeholder="请选择" v-model="listObj.topic_label_one" @change="articleLabel('1',$event,'topic')">
                  <el-option
                    v-for="item in topicOneList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.title">
                  </el-option>
                </el-select>
              </div>
              <div class="search-item">
                <p>题干二级标签：</p>
                <el-select  placeholder="请选择" v-model="listObj.topic_label_two" @change="articleLabel('2',$event,'topic')">
                  <el-option
                    v-for="item in topicTwoList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.title">
                  </el-option>
                </el-select>
              </div>
              <div class="search-item">
                <p>题干三级标签：</p>
                <el-select  placeholder="请选择" v-model="listObj.topic_label_three" @change="articleLabel('3',$event,'topic')">
                  <el-option
                    v-for="item in topicThreeList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.title">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
          <div class="titleList">
            <p v-for="item in studentTitle" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in studentList" v-bind:key="(index+1)" @click="topicChoose(item,index)">
              <p :title="item.key" class="radio" :class="topicID===index?'select':''">
                <span></span>
              </p>
              <p :title="item.content">{{item.content}}</p>
              <p :title="item.material_label_one">{{item.material_label_one}}</p>
              <p :title="item.material_label_two">{{item.material_label_two}}</p>
              <p :title="item.material_label_three">{{item.material_label_three}}</p>
              <p :title="item.topic">{{item.topic}}</p>
              <p :title="item.topic_label_one">{{item.topic_label_one}}</p>
              <p :title="item.topic_label_two">{{item.topic_label_two}}</p>
              <p :title="item.topic_label_three">{{item.topic_label_three}}</p>
              <p :title="item.answer">{{item.answer}}</p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="listObj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="listTotalPage">
            </el-pagination> 
          </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="studentSub">确定</button>
          <button class="btn btn-close" @click="studentHide">取消</button>
        </div>
      </div>

      <!-- 习题刻意练习 编辑 -->
      <div class="MobelBox" v-else-if="buildType">
        <p class="add-title">习题刻意练习</p>
        <button class="btn btn-hide"  @click="closeSub">关闭</button>
        <div class="write-txt">
          <p class="write-title"><span>*</span>文章内容：</p>
          <div class="write-text">
            <textarea placeholder="请输入文章内容" v-model="buildObj.content"></textarea>
          </div>
        </div>

        <!-- <div class="write-txt">
          <p class="write-title"><span>*</span>习题讲解稿：</p>
          <div class="write-text">
            <textarea placeholder="请输入习题讲解稿" v-model="buildObj.explain"></textarea>
          </div>
        </div> -->
        
        <div class="topicList">
          <div class="topic-item" v-for="(item,index) in buildObj.topic" :key="index">
            <div class="topic-title">
              题目{{(index+1)}}
              <button class="btn btn-remove" @click="removeTopic(item,index,'build')">删除</button>
            </div>
            <div class="write-txt">
              <p class="write-title"><span>*</span>题干：</p>
              <div class="write-text">
                <textarea placeholder="清输入题干" v-model="item.topic"></textarea>
              </div>
            </div>

            <div class="write-txt">
              <p class="write-title"><span>*</span>答案：</p>
              <div class="write-text">
                <textarea placeholder="请输入答案" v-model="item.answer"></textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title"><span>*</span>解题步骤：</p>
          <div class="write-text">
            <textarea placeholder="请输入解题步骤" v-model="buildObj.explain"></textarea>
          </div>
        </div>

        <div class="write-btnBox">
          <button class="btn btn-save" @click="buildHide">确定</button>
          <button class="btn btn-close" @click="buildHide">取消</button>
        </div>
      </div>


      <!-- 习题刻意练习 -->
      <div class="MobelBox IntentionallyBox" v-else>
        <p class="add-title">习题刻意练习</p>
        <button class="btn btn-hide"  @click="closeSub">关闭</button>
        <div class="write-txt hide">
          <p class="write-title"><span>*</span>训练周期：</p>
          <div class="write-text">
           <input type="text">
          </div>
          <button class="btn btn-topic-create">生成</button>
        </div>
        <div class="write-txt">
          <div class="videoUpload" v-for="(item,index) in addObj.topics" :key="index">
            <p class="weekTitle">第{{item.week}}周：{{item.week_name}}</p>
            <div class="video-item" v-for="(ele,num) in item.list" :key="num" :class="ele.is_update_topic==0?'noPointer':''">
              <div class="week-title">
                <p class="write-title"><span>*</span>练习题{{(num+1)}}：</p>
                <input type="text" v-model="ele.title">
              </div>
              <div class="write-text week-text">
                <textarea name="" id="" v-model="ele.content" disabled></textarea>
              </div>
              <button class="btn btn-topic-new" @click="chooseTopic(index,num)">{{ele.content?'重新选择':'选择'}}</button>
              <button class="btn btn-topic-build" @click="buildTopic(ele)">编辑</button>
              <button class="btn btn-topic-remove" v-if="num > 0" @click="removeTopic(index,num)">删除</button>
            </div>
            <button class="btn btn-topic-add" @click="addTopic(index)">+添加练习题</button>
          </div>
        </div>
        

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTopicDetail ,saveReadTopic ,getTypeLabelList ,CompositionTopicDetail ,ClassicTopicDetail,updateReadStatus ,delTopic,CompositionTopicSelectList ,ClassicsTopicSelectList,getReadDetail ,getTopicSelectList} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "index",
  data() {
    return {
      navId:'8',
      childrenID:'8-1',
      studentTitle:[
        {id:1,title:''},
        {id:2,title:'文章'},
        {id:3,title:'文章一级'},
        {id:4,title:'文章二级'},
        {id:5,title:'文章三级'},
        {id:6,title:'题干'},
        {id:7,title:'题干一级'},
        {id:8,title:'题干二级'},
        {id:9,title:'题干三级'},
        {id:10,title:'答案'},
      ],
      addType:'',
      listObj:{
        page:1,
        rows:10
      },
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{},
      listTotalPage:0,
      removeID:'',
      url:'',
      loading:false,
      loadTxt:'',
      listType:false,
      buildType:false,
      articleOneList:[],
      articleTwoList:[],
      articleThreeList:[],
      topicOneList:[],
      topicTwoList:[],
      topicThreeList:[],
      topicID:'',
      weekIndex:'',
      topicIndex:'',
      buildObj:{},
      is_up:1
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.token = userData.adminToken;
    this.url = this.$refs.navBox.url;
    this.is_up = this.$route.query.is_up
    this.getDetail();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.chooseTopic();
    },

    async getDetail(e,type){
      var that = this;      
      var id = this.$route.query.id
      try {
        const response = await getReadDetail({id:id,type:3},this.token);
        if(response.code == 200){
          response.data.topics.forEach(function(item,index){
            if(item.list.length == 0){
              item.list.push({content:'',topic:[]})
            }
          })
          that.addObj.topics = response.data.topics;
          that.addObj.id = id;
          that.$forceUpdate();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
    },

    async buildShow(e){
      var that = this;
      try {
        const response = await getReadDetail({id:e.id,type:1},this.token);
        if(response.code == 200){
          that.addObj = response.data;
          that.addObj.id = e.id;
          that.addType = 'edit';
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    async getLabelDetail(i,type){
      var that = this;
      var obj = {};
      if(i == 1){
        obj = {
          type:i,
          table_type:1
        }
        if(type == 'topic'){
          obj.table_type = 2
        }
      }
      if(i == 2){
        obj = {
          type : 2,
          one_id:that.value1,
          table_type:1
        };
        if(type == 'topic'){
          obj.one_id = this.topicValue1;
          obj.table_type = 2
        };
      }
      if(i == 3){
        obj = {
          type : 3,
          two_id:this.value2,
          table_type:1
        }
        if(type == 'topic'){
          obj.two_id = that.topicValue2;
          obj.table_type = 2
        }
      }
      try {
        const response = await getTypeLabelList(obj,this.token);
        if(response.code == 200){
          if(i == 2){
            if(type == 'article'){
              that.articleTwoList = response.data;
              that.articleTwoList.forEach(function(item,index){
                if(item.title == that.addObj.material_label_two){
                  that.value2 = item.id;
                }
              })
              that.getLabelDetail(3,'article');
            } else {
              that.topicTwoList = response.data;
              that.topicTwoList.forEach(function(item,index){
                if(item.title == that.addObj.topic_label_two){
                  that.topicValue2 = item.id;
                }
              })
              that.getLabelDetail(3,'topic');
            }
          }
          if(i == 3){
            if(type == 'article'){
              that.articleThreeList = response.data;
              that.articleThreeList.forEach(function(item,index){
                if(item.title == that.addObj.material_label_three){
                  that.value3 = item.id;
                }
              })
            } else {
              that.topicThreeList = response.data;
              that.topicThreeList.forEach(function(item,index){
                if(item.title == that.addObj.topic_label_three){
                  that.topicValue3 = item.id;
                }
              })
            }
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeShow(e){
      this.removeID = e.tmid;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delTopic({tmid:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      // if(this.addObj.title == ''){
      //   that.$message('请填写标题！');
      //   return false;
      // }
      // if(this.addObj.begin_date == ''){
      //   that.$message('请选择开始时间！');
      //   return false;
      // }
      // if(this.addObj.end_date == ''){
      //   that.$message('请选择结束时间！');
      //   return false;
      // }
      try {
        const response = await saveReadTopic(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.$router.push('/marketIndex')    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.$router.push('/marketIndex')
    },

    searchSub(){
      this.listObj.page = 1;
      this.studentList = [];
      this.chooseTopic();
    },

    resetSub(){
      this.listObj={
        page:1,
        rows:10,
      };
      this.studentList = [];
      this.chooseTopic();
    },

    async getTypeList(i,type,value){
      var that = this;
      var obj = {};
      if(i == 1){
        obj = {
          type:i,
          table_type:1
        }
        if(type == 'topic'){
          obj.table_type = 2
        }
      }
      if(i == 2){
        obj = {
          type : 2,
          one_id:value,
          table_type:1
        };
        if(type == 'topic'){
          obj.table_type = 2
        };
      }
      if(i == 3){
        obj = {
          type : 3,
          two_id: value,
          table_type:1
        }
        if(type == 'topic'){
          obj.table_type = 2
        }
      }
      try {
        const response = await getTypeLabelList(obj,this.token);
        if(response.code == 200){
          if(i == 1){
            if(type == 'article'){
              that.articleOneList = response.data;
            } else {
              that.topicOneList = response.data;
            }
          }
          if(i == 2){
            if(type == 'article'){
              that.articleTwoList = response.data;
            } else {
              that.topicTwoList = response.data;
            }
          }
          if(i == 3){
            if(type == 'article'){
              that.articleThreeList = response.data;
            } else {
              that.topicThreeList = response.data;
            }
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    articleLabel(type,e,topic,num){
      var that = this;
      var value = ''
      if(type == 1){
        if(topic == 'topic'){
          that.listObj.topic_label_two = '';
          that.listObj.topic_label_three = '';
          that.topicOneList.forEach(function(item,index){
            if(item.title == that.listObj.topic_label_one){
              value = item.id;
            }
          })
          that.getTypeList(2,'topic',value);
        } else {
          that.listObj.material_label_two = '';
          that.listObj.material_label_three = '';
          that.articleOneList.forEach(function(item,index){
            if(item.title == that.listObj.material_label_one){
              value = item.id;
            }
          })
          that.getTypeList(2,'article',value);
        }
      } else if(type == 2){
        if(topic == 'topic'){
          that.topicTwoList.forEach(function(item,index){
            if(item.title == that.listObj.topic_label_two){
              value = item.id;
            }
          })
          that.getTypeList(3,'topic',value)
          that.listObj.topic_label_three = '';
        } else {
          that.articleTwoList.forEach(function(item,index){
            if(item.title == that.listObj.material_label_two){
              value = item.id;
            }
          })
          that.getTypeList(3,'article',value)
          that.listObj.material_label_three = '';
        }
      } else if(type == 3){
        if(topic == 'topic'){
          
        } else {
        }
        that.$forceUpdate()
      }
    },

    addTopic(index){
      var list = {content:'',topic:[]}
      this.addObj.topics[index].list.push(list);
      this.$forceUpdate();
    },

    removeTopic(index,num,type){
      if(type == 'build'){
        this.buildObj.topic.splice(num,1);
      } else {
        this.addObj.topics[index].list.splice(num,1);
      }
      this.$forceUpdate();
    },

    buildTopic(e){
      this.buildObj = e;
      this.buildType = true
    },

    studentSub(){
      var that = this;
      this.listType = false;
      this.topicID='';
    },

    studentHide(){
      this.listType = false;
      this.studentList = [];
    },

    async chooseTopic(i,n){
      var that = this;   
      if(i || i >= 0){
        this.weekIndex = i;   
      } 
      if(n || n>=0){
        this.topicIndex = n;
      };
      var url = '';
      if(this.$route.query.type == 1){
        url = await getTopicSelectList(this.listObj,this.token);
      } else if(this.$route.query.type == 3){
        url = await ClassicsTopicSelectList(this.listObj,this.token);
      } else {
        url = await CompositionTopicSelectList(this.listObj,this.token);
      }
      try {
        const response = url;
        if(response.code == 200){
          that.listType = true;
          that.studentList = response.data.list;
          that.addType = '';
          that.listTotalPage = response.data.total_page;
          that.getTypeList(1,'article')
          that.getTypeList(1,'topic')
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async topicChoose(e,i){
      var that = this; 
      if(that.topicID === i){
        return false;
      }
      var url = '';
      if(this.$route.query.type == 1){
        url = await getTopicDetail({tmid:e.tmid},this.token);
      } else if(this.$route.query.type == 3){
        url = await ClassicTopicDetail({tmid:e.tmid},this.token);
      } else {
        url = await CompositionTopicDetail({tmid:e.tmid},this.token);
      }
      try {
        const response = url
        if(response.code == 200){
          that.addObj.topics[that.weekIndex].list[that.topicIndex].topic = [];
          that.topicID = i
          that.addObj.topics[that.weekIndex].list[that.topicIndex].content = response.data.content;
          that.addObj.topics[that.weekIndex].list[that.topicIndex].explain = response.data.explain;
          response.data.topic.forEach(function(item,index){
            that.addObj.topics[that.weekIndex].list[that.topicIndex].topic.push({topic:item.topic,answer:item.answer})
          });
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    buildHide(){
      this.buildType = false;
      this.buildObj = {};
      this.topicID = '';
    }
  }

 

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 10 );
  }

  /* .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 10px;
  } */

  .add-title,
  .list-title{
    color: #333333;
    font-size: 24px;
    display: block;
    margin-bottom: 20px;
    position: relative;
    padding-left: 20px;
  }

  .add-title::before,
  .list-title::before{
    content: '';
    width: 5px;
    height: 22px;
    background-color: #6098F2;
    position: absolute;
    top: 50%;
    transform: translate(0,-50%);
    left: 5px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 334px;
    background-color: #FFFFFF;
    border-radius: 6px;
    display: block;
    padding: 20px;
    box-sizing: border-box;
    border: solid 1px #333333;
    font-size: 16px;
  }

  .MobelBox input{
    height: 50px;
    line-height: 50px;
    width: 500px;
  }

  .MobelBox>>> .el-input{
    font-size: 16px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-topic-create{
  background-color: #6098F2;
  border-radius: 6px;
  color: #fff;
  font-size: 18px;
  color: #fff;
  box-sizing: border-box;
  padding: 0px 20px;
  height: 50px;
  line-height: 50px;
  display: inline-block;
  margin-left: 20px;
}

.MobelBox .write-ai .write-text{
  width: auto;
}

.MobelBox>>> .el-radio__inner{
  width: 20px;
  height: 20px;
}

.MobelBox>>> .el-radio{
  line-height: 50px;
}

.MobelBox>>> .el-radio__label{
  font-size: 18px;
}

.MobelBox>>> .el-radio__inner::after{
  width: 10px;
  height: 10px;
}

.topicList{
  display: block;
}

.topic-title{
  font-size: 20px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-bottom: 20px;
}

.topic-title .btn-add,
.topic-title .btn-remove{
  font-size: 18px;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  background-color: #6098F2;
  background-image: none;
  width: 110px;
  border-radius: 6px;
}

.topic-title .btn-add{
  background-color: #F5F5F5;
  color: #999999;
  margin-left: 20px;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}

.btn-topic-add{
  font-size: 16px;
  color: #6098F2;
  margin-top: 30px;
  display: block;  
  border: solid 1px #6098F2;
  border-radius: 6px;
  padding: 5px 15px;
  box-sizing: border-box;
}

.studentList .searchBox {
  padding: 0;
  margin-top: 25px;
  float: none;
}

.studentList .searchBox .search-item p{
  width: 100px;
  padding: 0;
}

.studentList .titleList{
  background-color: #F0F4FB;
  margin-top: 20px;
}

.studentList .dataList .listItem p,
.studentList .organiza-list p{
  width: calc( 100% / 10 );
  padding: 21px 5px;
  white-space: nowrap; /* 禁止文本换行 */
  overflow: hidden; /* 隐藏超出范围的内容 */
  text-overflow: ellipsis; /* 使用省略号 */
}

.studentList .dataList .listItem p.radio span{
  width: 20px;
  height: 20px;
  background-color: #D9D9D9;
  border-radius: 4px;
  display: block;
}

.studentList .dataList .listItem p.select span{
  background-color: #6098F2;
}

.studentList .dataList .listItem p.select span::before{
  content: '✔';
  width: 20px;
  height: 20px;
  display: block;
  color: #ffff;
  margin: 0 5px;
}

.studentList>>> .el-radio__inner{
    width: 20px;
    height: 20px;
    border-width:  2px;
  }

  .studentList>>> .el-radio__label{
    font-size: 18px;
    display: none;
  }

  .studentList>>> .el-radio__inner::after{
    width: 10px;
    height: 10px;
  }

.videoUpload{
  font-size: 0;
  margin-bottom: 30px;
}

.videoUpload .weekTitle{
  font-size: 20px;
  position: relative;
  margin: 0 0 20px 45px;
}


.videoUpload .weekTitle::before{
  content: '';
  width: 5px;
  height: 18px;
  background-color: #6098F2;
  position: absolute;
  top: 50%;
  -webkit-transform: translate(0,-50%);
  transform: translate(0,-50%);
  left: -15px;
}

.videoUpload .video-item{
  padding: 0 70px;
  box-sizing: border-box;
  margin-top: 20px;
}

.IntentionallyBox .videoUpload .video-item .btn{
  font-size: 18px;
  color: #333333;
  border: solid 1px #333333;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 9px 20px;
  display: inline-block;
  vertical-align: top;
  margin-left: 20px;
}

.IntentionallyBox .videoUpload .video-item .btn.btn-topic-remove{
  background-color: #6098F2;
  color: #fff;
  border: solid 1px transparent;
}

.IntentionallyBox .videoUpload .video-item textarea{
  width: 430px;
  height: 112px;
  border: solid 1px #ECECEC;
  margin-left: 20px;
}

.IntentionallyBox .write-text{
  width: auto;
}

.videoUpload .btn-video-add{
  font-size: 18px;
  color: #fff;
  padding: 5px 20px;
  border-radius: 6px;
  background-color: #6098F2;
  margin-left: 20px;
}

.MobelBox.explainBox .write-text{
  width: auto;
}

/* .workBox */
.workBox .dataList .listItem p, 
.workBox .organiza-list p{
  width: calc( 100% / 6 );
}

.week-list{
  font-size: 0;
}

.week-date{
  font-size: 0;
  margin-bottom: 30px;
}

.week-date p{
  color: #777777;
  font-size: 22px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 20px;
}

.week-date p.select{
  font-size: 26px;
  color: #333333;
  border-bottom: solid 4px #6098F2;
  padding-bottom: 6px;
}

.week-list .week-txt{
  font-size: 18px;
  color: #999999;
  box-sizing: border-box;
  padding: 9px 35px;
  border-radius: 6px;
  background-color: #F5F5F5;
  margin-right: 20px;
  display: inline-block;
  vertical-align: top;
}

.week-list .week-txt.select{
  background-color: #6098F2;
  color: #fff;
}

.workExamBox .btn-play{
  width: 144px;
  height: 40px;
  color: #fff;
  background-color: #6098F2;
  border-radius: 6px;
  font-size: 18px;
}

.workExamBox .btn-play{

}

.wrong-title{
  font-size: 24px;
  color: #333333;
  margin-bottom: 20px;
}

.btn-choose{
  font-size: 18px;
  color: #fff;
  padding: 5px 20px;
  border-radius: 6px;
  background-color: #6098F2;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: middle;
  margin-left: 15px;
}

.week-title{
  display: block;
  font-size: 0;
  margin-bottom: 20px;
}

.week-title input,
.week-title p{
  display: inline-block;
  vertical-align: top;
}

.IntentionallyBox .write-text.week-text{
  margin-left: 70px;
}
</style>



// WEBPACK FOOTER //
// src/marketing/exercises.vue